import { render, staticRenderFns } from "./FormAuthorityConfig.vue?vue&type=template&id=7ce703b3&scoped=true&"
import script from "./FormAuthorityConfig.vue?vue&type=script&lang=js&"
export * from "./FormAuthorityConfig.vue?vue&type=script&lang=js&"
import style0 from "./FormAuthorityConfig.vue?vue&type=style&index=0&id=7ce703b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce703b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ce703b3')) {
      api.createRecord('7ce703b3', component.options)
    } else {
      api.reload('7ce703b3', component.options)
    }
    module.hot.accept("./FormAuthorityConfig.vue?vue&type=template&id=7ce703b3&scoped=true&", function () {
      api.rerender('7ce703b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/process/comon/process/config/FormAuthorityConfig.vue"
export default component.exports